import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=3d246bda&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=3d246bda&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d246bda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d246bda')) {
      api.createRecord('3d246bda', component.options)
    } else {
      api.reload('3d246bda', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=3d246bda&scoped=true", function () {
      api.rerender('3d246bda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/questionConfig/subViews/preview/Main.vue"
export default component.exports